"use client"; // Ensure it runs on the client side

import React, { useRef } from 'react';
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper as SwiperType } from 'swiper/types';

// Import Swiper styles (Required)
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ENV } from '@/app/environment/environment';

const SwiperBanner = () => {
  const swiperRef = useRef<SwiperType | null>(null);
  const elements = [
    { image: "banner-1.png" },
    { image: "banner-2.png" }
  ];

  return (

    <div>
      <div onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
      onMouseLeave={() => swiperRef.current?.autoplay?.start()}
    >
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        spaceBetween={30}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        modules={[Pagination, Navigation, Autoplay]}
        className="w-full"
        style={{ marginBottom: '1rem' }}
      >
        {elements.map((el, index) => (
          <SwiperSlide key={index} className="h-[400px] flex items-center">
            <div className="mt-1 border border-gray-300 bg-black">
              <Image
                src={`${ENV.bucket}/images/${el.image}`}
                alt={`Banner ${index + 1}`}
                width={1200} // Adjust width
                height={400} // Adjust height
                className="w-full h-auto"
                priority={true}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    </div>

  );
};

export default SwiperBanner;
